import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const archiveEventTemplate = async (uuid: string) => {
  const response = await CustomAxios.post(`event_templates/${uuid}/archive`);
  return response.data;
};

interface UseArchiveEventTemplateProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useArchiveEventTemplate({ uuid, onSuccessCallback }: UseArchiveEventTemplateProps) {
  return useMutation({
    mutationFn: () => archiveEventTemplate(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEventTemplates, uuid] });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to archive the event template. Please try again and contact support if the problem persists.');
      }
    },
  });
}
